/**
 * @Author: Zero
 * @Date: 2023-02-24 14:50:49
 * @Explain: Home
 */
import http from '../http';
import type {
  CampaignsResponse,
  LineResponse,
  PieResponse,
  ToDoListResponse,
} from './data.d';

const MODEL = '/home';
const SETTINGS = '/settings';

export default {
  // campaigns
  getCampaigns(data: Record<any, any>): Promise<CampaignsResponse> {
    return http.post(`${MODEL}/campaigns`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // subscribers
  getSubscribers(data: Record<any, any>): Promise<LineResponse> {
    return http.post(`${MODEL}/subscribers`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // Regional and language distribution of subscribers
  getDistributionSubscribers(data: Record<any, any>): Promise<PieResponse> {
    return http.post(`${MODEL}/distribution-subscribers`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  // ToDoList
  getToDoList(): Promise<ToDoListResponse> {
    return http.post(`${MODEL}/to-do-list`);
  },
  // 更新todolist是否提示双因素认证记录 & 用户活动报表所有周期说明状态
  updateRemberInfo(data: Record<any, any>) {
    return http.post(`${SETTINGS}/add_action_record`, data);
  },
};
